import Axios from "axios";

const url_api = process.env.VUE_APP_API_URL;

export function getAll() {
  return Axios.get(url_api + "/api/billboards");
}

export function get(id) {
  return Axios.get(url_api + "/api/billboards/" + id);
}

export function groups() {
  return Axios.get(url_api + "/api/groups");
}

export function group(id) {
  return Axios.get(url_api + "/api/groups/" + id);
}

export function types() {
  return Axios.get(url_api + "/api/types");
}

export function type(id) {
  return Axios.get(url_api + "/api/types/" + id);
}

export function facings() {
  return Axios.get(url_api + "/api/facings");
}

export function facing(id) {
  return Axios.get(url_api + "/api/facings/" + id);
}
